import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { Container } from './styles';

interface ChartProps {
  data: Array<number>;
  categories: Array<number | string>;
  title: string;
}

export function HistoricPaymentChart({ data, categories, title }: ChartProps) {
  const options: ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      foreColor: '#6b6b6b6b',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories,
      labels: {
        style: {
          fontSize: window.innerWidth < 1366 ? '8px' : '11px',
          fontWeight: 600,
        },
      },
    },
    grid: {
      show: true,
    },
    yaxis: {
      show: true,
      labels: {
        formatter: (val) => {
          return new Intl.NumberFormat('pt-Br', {
            style: 'currency',
            currency: 'BRL',
          }).format(val);
        },
        style: {
          fontSize: window.innerWidth < 1366 ? '8px' : '11px',
          fontWeight: 600,
        },
      },
    },
    fill: {
      colors: ['#b7cb21'],
    },
  };

  const series = [
    {
      data,
    },
  ];

  return (
    <Container>
      <h1>{title}</h1>
      {/* @ts-ignore*/}
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height="90%"
        width="100%"
      />
    </Container>
  );
}
